import React from 'react'
import { ListItem, ListItemText, Typography } from '@mui/material'
import { useSelector } from 'react-redux'

import { withStyles } from '@mui/styles'
import { style } from 'styles'
import { formatNumber } from 'core/lib'

function ProductList({ gotoProduct, product }) {
	const shop = useSelector(state => state.shop)

	return (<ListItem onClick={() => gotoProduct(product)}>
		<ListItemText
			className="product list"
			primary={<React.Fragment>
				<Typography
					component="div"
					variant="body1"
					className="title"
				>
					{product.html_title && product.html_title != '' && <span className="title" dangerouslySetInnerHTML={{
						__html: product.html_title
					}}></span>}
				</Typography>
				<Typography
					component="div"
					variant="body2"
					className="price"
				>
					{product.offer_active && <del>{formatNumber(product.item_price)} €</del>}
					{formatNumber(product.price)} €
				</Typography>
				{shop.profiles.ueby_item_quantity_check == 1 && <Typography
					component="div"
					variant="body2"
					className="availability"
				>
					Disponibilità {product.quantity}
				</Typography>}
			</React.Fragment>}
			secondary={<span className="description">{product.description}</span>}
		/>
	</ListItem>)
}

export default withStyles(style)(ProductList)
